import { Component, OnInit, Input } from '@angular/core';
import {PlaylistsService}  from "../shared/services/playlists.service";
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {switchMap, map} from 'rxjs/operators';
import {domain, protocol} from '../shared/config';
 import {  NbToastrService, NbGlobalPosition } from '@nebular/theme';

@Component({
  selector: 'app-playlist-page',
  templateUrl: './playlist-page.component.html',
  styleUrls: ['./playlist-page.component.scss']
})
export class PlaylistPageComponent implements OnInit {
  

  
  initialLoading = true
  itemsUpdated = false
   playlist: any
   playlist$:any
   selectedItem = [] 
   fullSelectList:any = []
   selectList = []
   togglePublish$:any
   saveItems$:any
   publish: boolean
  domain: any = {
    name: domain, protocol
  }


  channelUrl = false
  
  itemsLoading = false

  sortablejsOptions: any = {
     group: 'items',
     handle: '.sortPlaylistItem',
    // scroll: true,
   //  scrollSensitivity: 200,
    onUpdate: () => { 
        	this.itemsUpdated = true
    } 

  };

  playlistItems = []

   constructor(
    public playlistsService: PlaylistsService,
    private toastrService: NbToastrService,
    public route:  ActivatedRoute  ){
 
   }

  ngOnInit() { 
   		// setTimeout(()=>{this.playlistItems.push({...this.playlistItems[0]})},15000)


	  this.playlist$ = this.route.params.pipe(
      switchMap((params: Params)=>{
        
        return this.playlistsService.getById(params['id']).pipe(
          map((data: any)=>{

		 
              this.initialLoading = false  
            this.publish = data.playlist.publish
            this.playlist = data.playlist
	    this.fullSelectList = data.itemsList
	  this.channelUrl = data.channelUrl
	    this.playlistItems = [...this.playlist.items]

	    this.updateSelectList()

            return data.playlist
          })
        )
      })
    ).subscribe()
  
 
  }
 
   updateSelectList(unselect = false){
         if(unselect){
	  this.selectedItem = []
	}

 

        let selectedItems =  this.playlistItems.map(i => i._id)
	//console.log(selectedItems)
	let items = {...this.fullSelectList}

	 items.videos = items.videos.filter(v => !selectedItems.includes(v._id)  )
	 items.streams = items.streams.filter(s => !selectedItems.includes(s._id) )
	this.selectList = {...items}
	
   }


  addItem(){
	if(this.selectedItem?.length){ 
                 this.playlistItems = this.selectedItem.concat(this.playlistItems) 
		this.updateSelectList(true)
                this.itemsUpdated = true
	}
  }


   itemsRemoveHandler(event,item){
	this.itemsUpdated = true
	event.stopPropagation(); 
	this.playlistItems = this.playlistItems.filter(i=> i._id !== item._id)
        this.updateSelectList()
   }

   onItemsSave(){
	this.itemsUpdated = false
        this.updateSelectList(true)
	this.itemsLoading = true
	

     
        // setTimeout(()=>{this.itemsLoading = false},1000)

 

		let videos = 0;
		let streams = 0;

		
		let items = this.playlistItems.map(i => {  
					if(i.type === 'video'){
					 videos++;
				        } else { 
					 streams++; 
					} 
					return i._id;  })

			 

 	this.saveItems$ = this.playlistsService
    		.updateItems(this.playlist._id, items, videos,  streams )
	     .subscribe((playlist : any)=>{
  		

		    this.toastrService.show('','Плейлист збережено',{
		      status: 'success',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end'
			})
			
		this.itemsLoading = false
	    }, ()=>{

		   	this.itemsUpdated = true

		    this.toastrService.show('','Сталася помилка збереження',{
		      status: 'danger',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end'
			})
			
 		this.itemsLoading = false
	    })
	 
	
   }
  	
  togglePublish(){

 
    this.togglePublish$ = this.playlistsService
    .updatePublish(this.playlist._id,this.publish)
	     .subscribe((playlist : any)=>{
 
	      this.publish = playlist.publish
	     this.playlist.publish = playlist.publish

	    }, ()=>{
	      this.publish = this.playlist.publish
	    })
	 
  }


 
   
   ngOnDestroy() { 
 	if( this.playlist$ ){
		 this.playlist$.unsubscribe()
		}
       if(this.togglePublish$){

	 this.togglePublish$.unsubscribe()
	}

       if(this.saveItems$){

	 this.saveItems$.unsubscribe()
	}
   }
 
}
